import React, { useState } from 'react';
import { MdOutlineEmail, MdArrowForward } from 'react-icons/md';

const FindQuote = () => {
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState('idle'); // idle | loading | sent | error
    const [error, setError] = useState('');

    const validate = () => {
        if (!email.trim()) return 'Email address is required.';
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))
            return 'Please enter a valid email address.';
        return null;
    };

    const handleSubmit = async () => {
        const validationError = validate();
        if (validationError) {
            setError(validationError);
            return;
        }
        setError('');
        setStatus('loading');

        try {
            const response = await fetch('api/ContinueQuote/SendContinueLink', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Email: email.trim() }),
            });

            if (!response.ok) throw new Error('Request failed');

            setStatus('sent');
        } catch (err) {
            console.error('SendContinueLink error:', err);
            setError('Something went wrong. Please try again.');
            setStatus('idle');
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') handleSubmit();
    };

    return (
        <div className="page-centered">
            <div className="card" style={{ width: '100%', maxWidth: '660px' }}>

                {status !== 'sent' ? (
                    <>
                        <div style={{ textAlign: 'left', marginBottom: 'var(--space-xl)' }}>
                            <h4 className="text-h1" style={{ margin: '0 0 var(--space-xs)' }}>
                                Welcome back
                            </h4>
                            <p className="text-default" style={{ margin: 0 }}>
                                Enter your email and we'll send you a secure link to continue
                                your quote.
                            </p>
                        </div>

                        {/* Email */}
                        <div className="form-group">
                            <label className="text-label">Enter your email address</label>
                            <div className="input-icon-wrap">
                                <span className="input-icon">
                                    <MdOutlineEmail size={16} />
                                </span>
                                <input
                                    type="email"
                                    placeholder="Email"
                                    value={email}
                                    onChange={(e) => {
                                        setEmail(e.target.value);
                                        setError('');
                                    }}
                                    onKeyPress={handleKeyPress}
                                    disabled={status === 'loading'}
                                />
                            </div>
                            {error && (
                                <span className="error-text" style={{margin: ".5rem 0", zIndex: 1}}>{error}</span>
                            )}
                        </div>

                        <div style={{ marginTop: 'var(--space-xs)' }}>
                            <button
                                className="btn"
                                onClick={handleSubmit}
                                disabled={status === 'loading'}
                                style={{ width: '100%' }}
                            >
                                {status === 'loading' ? 'Sending…' : 'Send Link'}
                                {status !== 'loading' && <MdArrowForward size={16} />}
                            </button>
                        </div>
                    </>
                ) : (
                    <div style={{ padding: 'var(--space-lg) 0' }}>
                        <h4 className="text-h1" style={{ margin: '0 0 var(--space-sm)' }}>
                            Check your email
                        </h4>
                        <p className="text-default" style={{ margin: '0 0 var(--space-md)' }}>
                            If an active quote exists for{' '}
                            <strong>{email}</strong>, a secure link has been sent.
                            The link expires in <strong>30 minutes</strong>.
                        </p>
                        <button
                            className="btn signup-cta btn--inverse-cta"
                            onClick={() => {
                                setStatus('idle');
                                setEmail('');
                            }}
                            style={{ width: '100%' }}
                        >
                            Try a different email
                        </button>
                    </div>
                )}

                <p className="text-small" style={{ textAlign: 'center', margin: 'var(--space-md) 0 0' }}>
                    Need assistance?{' '}
                    Call us at <a href="tel:8772695422">877-269-5422</a> to connect.
                </p>

            </div>
        </div>
    );
};

export default FindQuote;